import type { OrderStatus } from '@crm/shared'
import { ORDER_STATUS_STYLE, orderStatusLabel } from '../orderFormat'

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${ORDER_STATUS_STYLE[status]}`}
    >
      {orderStatusLabel(status)}
    </span>
  )
}
